<template>
<div class="animated fadeIn">

  <div class="row">
    <div class="col-12">
      <b-card v-if="$auth.check('manage-multiple-resavation')" no-body>
        <b-card-body>
          <b-form-checkbox v-if="$auth.check('manage-multiple-resavation')" class="mb-1" v-model="allowMultiple">Allow rooms to be assigned to multiple applications</b-form-checkbox>
          <div v-if="allowMultiple">
            <reservation-selected :reservations="selectedReservations" @uncheck="unCheck"></reservation-selected>
            <b-button class="mr-1" variant="outline-primary" :disabled="selectedReservations.length == 0" @click="showMultipleManualMatching">Multiple Manual</b-button>
            <b-button class="mr-1" variant="outline-primary" :disabled="selectedReservations.length == 0" @click="showMultipleAutoMatching">Multiple Auto</b-button>
          </div>
        </b-card-body>
      </b-card>
      <b-card>
        <v-server-table :columns="columns" url="/admin/reservations?status=HOLD,NEW,PAID" :options="options" :theme="theme" id="dataTable" ref="dataTable">
          <template slot="child_row" slot-scope="data">
            <b-card v-if="data.row.is_child" no-body>
              <reservation-parents :reservations="data.row.parents"></reservation-parents>
            </b-card>
            <b-row>
              <b-col lg="6">
                <b-table :items="data.row.members" :fields="fields" striped></b-table>
              </b-col>
              <b-col lg="6">
                <b-card title="Comments">{{ data.row.comments }}</b-card>
              </b-col>
            </b-row>                   
          </template>
          <template slot="id_card_no" slot-scope="data">
            {{ data.row.id_card_no ? data.row.id_card_no : translateReason(data.row.id_card_reason) }}
          </template>
          <template slot="created_at" slot-scope="data">
            {{ $moment(data.row.created_at).format('YYYY-MM-DD') }}
          </template>
          <template slot="checkbox" slot-scope="data">
            <b-form-checkbox v-if="allowMultiple && !data.row.is_child && data.row.status == 'NEW' && $auth.check('manage-multiple-resavation')" variant="outline-primary" class="text-center" v-model="selectedReservationObject[data.row.id]" :value="data.row" :unchecked-value="null"></b-form-checkbox>
          </template>
          <template slot="is_child" slot-scope="data">
            {{ data.row.is_child ? 'Yes' : 'No' }}
          </template>
          <template slot="actions" slot-scope="data">
            <b-button v-if="!allowMultiple && data.row.status == 'NEW' && $auth.check('resavation-assign-room')" size="sm" class="mr-1" variant="outline-primary" @click="showRoomMatching(data.row)">Manual</b-button>
            <b-button v-if="(data.row.status == 'HOLD' || data.row.status == 'PAID') && $auth.check('resavation-edit') " size="sm" class="mr-1"variant="outline-warning" @click="showRoomMatching(data.row)">Edit</b-button>
            <b-button v-if="(data.row.status == 'HOLD' || data.row.status == 'NEW')  && $auth.check('resavation-delete') " size="sm" class="mr-1" variant="outline-danger" @click="confirmDelete(data.row)">Delete</b-button>            
            <b-button v-if="!allowMultiple && data.row.status == 'NEW' && $auth.check('resavation-assign-building')" size="sm" class="mr-1" variant="outline-primary" @click="showReservationBuilding(data.row)">AssignBuilding</b-button>
          </template>
        </v-server-table>
      </b-card>
    </div><!--/.col-->
  </div><!--/.row-->
  <div>
    <b-modal ref="modalManualMatching" title="Room Matching" hide-footer @hide="hideRoomMatching" size="lg">
      <single-manual-matching v-if="selectedReservation" :reservation="selectedReservation" @payment="processPayment" @change="changeStatus" @cancel="cancelRoomMatching" />
    </b-modal>
    <b-modal ref="modalAutoMatching" title="Room Auto Matching" hide-footer @hide="hideRoomAutoMatching" size="lg">
      <single-auto-matching v-if="selectedAutoReservation" :reservation="selectedAutoReservation" @change="changeStatus" @cancel="cancelRoomAutoMatching" />
    </b-modal>
    <b-modal ref="modalConfirm" title="Delete Reservation" @ok="deleteReservation">
      <div v-if="selectedReservation" class="d-block text-center">
        <h4>Are you sure you want to delete this reservation?</h4>
      </div>
    </b-modal>

    <b-modal ref="modalMultipleAutoMatching" title="Multiple Auto Matching" hide-footer size="lg">
      <multiple-auto-matching v-if="selectedReservations.length > 0" :reservations="selectedReservations" @submit="submitMultiple" />
    </b-modal>
    <b-modal ref="modalMultipleManualMatching" title="Multiple Manual Matching" hide-footer size="lg">
      <multiple-manual-matching v-if="selectedReservations.length > 0" :reservations="selectedReservations" @submit="submitMultiple" />
    </b-modal>
    <b-modal ref="modalReservationBuilding" title="Reservation Building" hide-footer size="lg">
      <reservation-building-modal v-if="selectedReservation" :reservation="selectedReservation" @success="hideReservationBuilding" />
    </b-modal>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'
import SingleManualMatching from './SingleManualMatching'
import SingleAutoMatching from './SingleAutoMatching'
import ReservationSelected from './ReservationSelected'
import MultipleAutoMatching from './MultipleAutoMatching'
import MultipleManualMatching from './MultipleManualMatching'
import ReservationParents from './ReservationParents'
import ReservationBuildingModal from './ReservationBuildingModal'



export default {
  name: 'ReservationsList',
  components: {
    SingleManualMatching,
    SingleAutoMatching,
    ReservationSelected,
    MultipleAutoMatching,
    MultipleManualMatching,
    ReservationParents,    
    ReservationBuildingModal
  },
  computed: {
    selectedReservations() {
      let selected = [];
      _.map(this.selectedReservationObject, (reservation) => {
        if (reservation != null) {
          selected.push(reservation)
        }
      })
      return selected;
    },   
  },
  data: function() {
    return {
      allowMultiple: false,
      showManual : false,
      selectedReservationObject: {},
      selectedReservation: null,
      selectedAutoReservation: null,
      fields: ['name', 'age', 'i_card_number'],      
      columns: [
        'event_type.name',
        'id_card_no',
        'application_number',
        'applicant_name',
        'customer.city',
        'members_count',       
        'arrival_date',
        'departure_date',
        'is_child',
        'count_assigned_rooms',
        'status',
        'checkbox',
        'building.name',
        'created_at',
        'actions'
      ],
      options: {
        headings: {
          'event_type.name': 'Bhandara/Satsang',
          id_card_no: 'Id Card (or reason)',
          application_number: 'Reservation Reference',
          applicant_name: 'Applicant',
          'customer.city': 'City',
          members_count: 'Members',
          arrival_date: 'Arrival',
          departure_date: 'Departure',
          count_assigned_rooms: 'Rooms',
          checkbox: 'Selected',
          'building.name': 'Assigned Building',
          is_child: 'Combined'
        },
        sortable: ['created_at', 'arrival_date', 'departure_date', 'status', 'members_count', 'is_child'],
        filterable: ['application_number'],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
        responseAdapter: function(response) {
          var data = this.getResponseData(response);
          return {
            data: data.data,
            count: data.meta.pagination.total
          }
        },
        cellClasses:{
          is_child: [
            {
                class:'font-weight-bold',
                condition: row => row.is_child == 1
            }
          ]
        }
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },
  methods: {
    showReservationBuilding(reservation) {
      this.selectedReservation = reservation   
      this.$refs.modalReservationBuilding.show();
    },
    cancelReservationBuilding() {
      this.$refs.modalReservationBuilding.hide()
    },
    hideReservationBuilding() {
      this.selectedReservation = null
      this.$refs.modalReservationBuilding.hide()
      this.$refs.dataTable.refresh()
    },
    showRoomMatching(reservation) {
      this.selectedReservation = reservation   
      this.$refs.modalManualMatching.show()
    },
    cancelRoomMatching() {
      this.$refs.modalManualMatching.hide()
    },
    changeStatus() {
      this.$refs.modalManualMatching.hide()
      this.$refs.modalAutoMatching.hide()
      this.$refs.dataTable.refresh()
    },
    hideRoomMatching() {
      this.selectedReservation = null
      this.$refs.dataTable.refresh()
    },
    showRoomAutoMatching(reservation) {
      this.selectedAutoReservation = reservation
      this.$refs.modalAutoMatching.show()
    },
    cancelRoomAutoMatching() {
      this.$refs.modalAutoMatching.hide()
    },
    hideRoomAutoMatching() {
      this.selectedAutoReservation = null
      this.$refs.dataTable.refresh()
    },
    confirmDelete(reservation) {
      this.selectedReservation = reservation
      this.$refs.modalConfirm.show()
    },
    processPayment(reservation) {
      this.$refs.modalManualMatching.hide()
      this.selectedReservation = reservation
      this.$refs.modalPayment.show()
    },
    deleteReservation() {
      this.$store.dispatch('reservations/deleteReservation', {id: this.selectedReservation.id})
      .then(() => {
        this.showSuccessMsg()
        this.$refs.dataTable.refresh()
      })
      .catch((error) => {
        if (error.response.status == 400) {
          this.showErrorMsg({
            message: error.response.data.message
          })
        } else {
          this.showErrorMsg()
        }
      })
    },
    unCheck(id) {
      this.selectedReservationObject[id] = null
    },
    showMultipleManualMatching() {
      this.$refs.modalMultipleManualMatching.show()
    },
    showMultipleAutoMatching() {
      this.$refs.modalMultipleAutoMatching.show()
    },
    submitMultiple() {
      this.$refs.modalMultipleAutoMatching.hide()
      this.$refs.modalMultipleManualMatching.hide()
      this.selectedReservationObject = {}
      this.$refs.dataTable.refresh()
    },
    translateReason(reason) {
      switch (reason) {
        case 'NEW_TO_SATSANG':
          return 'New to Satsang'
        case 'SUPPORT_ELDER_PERSON':
          return 'Support to elder person'
        case 'CHILD':
          return 'Child'
      }
      return ''
    }
  },
  created(){
  }
}
</script>
